<template>
  <div class="main-container">
    <!-- Navigation -->
    <div class="navigation">
      <div class="nav-brand" :class="{ onsidebar: $store.state.sidebar }">
        <button class="menu-btn" @click="menuClick()">
          <img src="@/assets/images/icons/black-main-menu.svg" class="bl-menu" />
          <img src="@/assets/images/icons/white-main-menu.svg" class="wh-menu" />
        </button>
        <img v-if="websiteTheme && websiteTheme.webLogo && !$store.state.sidebar" class="logo"
          :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + websiteTheme.webLogo" />
        <!-- <img v-else @click="$router.push({ name: 'home' }).catch(() => { })" src="@/assets/images/logo.svg"
          class="logo" /> -->
      </div>
      <div class="nav-options">
        <div class="btn-container" v-if="$getLoggedUser() &&
          $getLoggedUser().user.account_type == 'wecodefystaff'
        ">
          <span class="not-number">0</span>
          <button class="nav-button">
            <img width="21" src="@/assets/images/icons/mail.svg" />
          </button>
        </div>
        <div class="btn-container" v-if="$getLoggedUser() &&
          $getLoggedUser().user.account_type == 'wecodefystaff'
        ">
          <span class="not-number">0</span>
          <button class="nav-button">
            <img width="23" src="@/assets/images/icons/ring.svg" />
          </button>
        </div>
        <div class="btn-container">
          <button v-if="$getLoggedUser() && $getLoggedUser().user.profile_image" ref="settings-menu"
            class="nav-button profile-btn" @click="show_settings_menu = true">
            <img class="profile-logo" :src="$store.state.ASSETS_BASE_URL +
              'assets/uploaded/' +
              $getLoggedUser().user.profile_image
              " />
          </button>
          <button v-else class="nav-button profile-btn" ref="settings-menu"
            @click="show_settings_menu = !show_settings_menu">
            <div class="empty-profile" v-if="$getLoggedUser()">
              {{
                $nameInitials(
                  $getLoggedUser().user.first_name +
                  " " +
                  $getLoggedUser().user.last_name
                )
              }}
            </div>
          </button>
          <div class="settings-drop-down" v-if="$getLoggedUser() && show_settings_menu" v-closable="{
            exclude: ['settings-menu'],
            handler: 'hideSettingsMenu',
          }">
            <div class="profile-widget">
              {{
                $getLoggedUser().user.first_name +
                " " +
                $getLoggedUser().user.last_name
              }}
            </div>
            <!-- <div class="setting-item">
                <span class="fa fa-user icon"></span> <span>Profile</span>
              </div> -->
            <div class="setting-item" @click="logOut()">
              <span class="fa fa-lock icon"></span> <span>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-widget" :class="{ show: !$store.state.sidebar }">
      <div class="system-brand">
        <button class="menu-btn" @click="menuClick()">
          <img src="@/assets/images/icons/white-main-menu.svg" />
        </button>
        <div class="brand">
          <img v-if="websiteTheme && websiteTheme.webLogo" class="logo"
            :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + websiteTheme.webLogo" />
          <img v-else class="logo" src="@/assets/images/logo.svg" />
        </div>


      </div>
      <!-- Staff menu -->
      <div class="menu-list" v-if="$getLoggedUser() &&
        $getLoggedUser().user.account_type == 'wecodefystaff'
      ">
        <ul>
          <li class="item" :class="{
            active: $route.name == 'dashboard' || $route.name == 'welcome',
          }" @click="navigateTo('dashboard')">
            <i class="fa fa-chart-line icon"></i>
            <span class="text">Dashboard</span>
          </li>

          <li class="item" :class="{ active: $route.name == 'chat_support' }" @click="navigateTo('chat_support')">
            <i class="fa fa-box icon"></i>
            <span class="text">Messaging</span>
          </li>

          <li class="item" :class="{ active: $route.name == 'finance' }" @click="navigateTo('finance')">
            <b-icon icon="finance"></b-icon>
            <span class="text">Finance</span>
          </li>

          <li class="item" :class="{ active: $route.name == 'ads' }" @click="navigateTo('ads')">
            <b-icon icon="bread-slice-outline"></b-icon>
            <span class="text">ADS REQUEST</span>
          </li>

          <li class="divider">LIBRARY</li>

          <li class="item" :class="{
            active: $route.name == 'channels',
          }" @click="navigateTo('channels')">
            <b-icon icon="lightbulb-group"></b-icon>
            <span class="text">PARTNERS</span>
          </li>
          <li class="item" :class="{ active: $route.name == 'streaming' }" @click="navigateTo('streaming')">
            <b-icon icon="access-point"></b-icon>
            <span class="text">TVs</span>
          </li>
          <li class="divider">SYSTEM</li>
          <li class="item" :class="{
            active: $route.name == 'members',
          }" @click="navigateTo('members')">
            <i class="fa fa-users icon"></i>
            <span class="text">Members</span>
          </li>
          <li class="item" :class="{
            active: $route.name == 'settings',
          }" @click="navigateTo('settings')">
            <i class="fa fa-cog icon"></i>
            <span class="text">Settings</span>
          </li>
        </ul>
      </div>
      <!-- Streamer menu -->
      <div class="menu-list" v-if="$getLoggedUser() && $getLoggedUser().user.account_type == 'streamer'
      ">
        <ul>
          <li class="item" :class="{ active: $route.name == 's_dashboard' }" @click="navigateTo('s_dashboard')">
            <b-icon icon="chart-bar"></b-icon>
            <span class="text">Dashboard</span>
          </li>
          <li v-if="showLibraryMenu" class="divider">LIBRARY</li>

          <li v-if="$checkPermission('video_storage')" class="item" :class="{ active: $route.name == 's_audiov' }"
            @click="navigateTo('s_audiov')">
            <b-icon icon="multimedia"></b-icon>
            <span class="text">AUD/VID</span>
          </li>


          <li class="item" v-if="$checkPermission('event_streaming')" :class="{ active: $route.name == 's_stream' }"
            @click="navigateTo('s_stream')">
            <b-icon icon="access-point"></b-icon>
            <span class="text">Stream</span>
          </li>

          <li class="item" v-if="$checkPermission('voting')" :class="{ active: $route.name == 's_voting' }"
            @click="navigateTo('s_voting')">
            <b-icon icon="vote"></b-icon>
            <span class="text">Voting</span>
          </li>

          <li class="item" v-if="$checkPermission('events')" :class="{ active: $route.name == 's_events' }"
            @click="navigateTo('s_events')">
            <b-icon icon="ticket"></b-icon>
            <span class="text">Events</span>
          </li>

          <li class="item" v-if="$checkPermission('donation')" :class="{ active: $route.name == 's_donation' }"
            @click="navigateTo('s_donation')">
            <b-icon icon="heart"></b-icon>
            <span class="text">Donation</span>
          </li>

          <li class="divider" v-if="showPricingMenu">FINANCE</li>
          <li class="item" v-if="showPricingMenu" :class="{
            active: $route.name == 's_pricing',
          }" @click="navigateTo('s_pricing')">
            <b-icon icon="calculator"></b-icon>
            <span class="text">Pricing</span>
          </li>
          <li class="divider">SETTINGS</li>
          <li class="item" :class="{ active: $route.name == 'settings_customization' }"
            @click="navigateTo('settings_customization')">
            <b-icon icon="ev-plug-chademo"></b-icon>
            <span class="text">Customization</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="body-container" :class="{ nosidebar: !$store.state.sidebar }">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  mounted() {
    let vm = this;
    vm.$emit("updateHead");
    vm.getWebsiteTheme();
  },
  head: {
    title: function () {
      return {
        inner: "Dashboard",
      };
    },
  },
  computed: {
    showLibraryMenu() {
      let vm = this;
      return vm.$checkPermission('video_storage') ||
        vm.$checkPermission('event_streaming') ||
        vm.$checkPermission('voting') ||
        vm.$checkPermission('events') ||
        vm.$checkPermission('donation');
    },
    showPricingMenu() {
      let vm = this;
      return vm.$checkPermission('video_storage') ||
        vm.$checkPermission('event_streaming') ||
        vm.$checkPermission('voting') ||
        vm.$checkPermission('events') ||
        vm.$checkPermission('donation');
    }
  },
  data: () => ({
    show_settings_menu: false,
    websiteTheme: null,
    isDev: process.env.NODE_ENV === "development",
  }),
  watch: {},
  methods: {
    getWebsiteTheme() {
      let vm = this;
      vm.$store.commit("START_LOADER");
      vm.$store
        .dispatch("ADMIN_USER_GET_WEBSITE_THEME")
        .then((response) => {
          if (response.data.return) {
            vm.websiteTheme = response.data.return;
            vm.$store.commit("SET_WEB_SITE_BASE_URL", response.data.return.webSiteBaseUrl);
          }
          setTimeout(() => {
            vm.$store.commit("STOP_LOADER");
          }, 800);
        })
        .catch(({ response }) => {
          setTimeout(() => {
            vm.$store.commit("STOP_LOADER");
          }, 800);
        });
    },
    navigateTo(name) {
      let vm = this;
      vm.$router.push({ name: name });
    },
    hideSettingsMenu() {
      let vm = this;
      vm.show_settings_menu = false;
    },
    menuClick() {
      let vm = this;
      vm.$store.dispatch("TOGGLE_SIDE_BAR", !vm.$store.getters.getSideBar);
    },
    logOut() {
      let vm = this;
      vm.$localStorage.remove("user_data");
      vm.$localStorage.remove("permission_list");
      vm.$router.push({ name: "login" });
    },
  },
};
</script>
<style lang="scss">
.main-container {
  .navigation {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    height: 60px;
    display: flex;
    justify-content: center;
    z-index: 999;
    background: #ffff;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    // background: #a7a7a7;
    @media (max-width: 638px) {
      background: var(--wecodefy-bg-color, #011616);
    }

    .brand {
      .logo {
        width: 150px;
      }
    }

    .search-widget {
      width: 340px;
      background: #fff;
      border-radius: 2px;

      .search-group {
        width: 100%;
        display: flex;
        padding: 0px 8px;

        input {
          height: 35px;
          border: none;
          background: transparent;
          width: 100%;
          padding-left: 10px;
          border: none;
          outline: none;

          &::placeholder {
            color: rgb(194, 193, 193);
          }
        }

        .search {
          background: transparent;
          border: none;
          width: 22px;
        }
      }
    }

    .nav-brand {
      display: flex;
      align-items: center;
      height: 70px;
      padding: 10px 0px;

      .menu-btn {
        border: none;
        background: transparent;
        display: block;
        padding-left: 20px;

        @media screen and (max-width: 500px) {
          margin-left: 0px;
          padding-left: 10px;
        }

        @media screen and (max-width: 330px) {
          margin-right: 3px;
        }

        img {
          width: 26px;

          &.bl-menu {
            @media (max-width: 638px) {
              display: none;
            }
          }

          &.wh-menu {
            @media (min-width: 638px) {
              display: none;
            }
          }
        }
      }

      .logo {
        height: 100%;
        margin-left: 2px;
        display: block;
        object-fit: contain;

        @media screen and (max-width: 500px) {
          display: block;
          width: 95px;
        }

        @media screen and (max-width: 330px) {
          width: 95px;
        }
      }
    }

    .nav-options {
      display: flex;

      .btn-container {
        position: relative;
        margin-left: 10px;
        display: flex;
        align-items: center;

        .not-number {
          position: absolute;
          top: -10px;
          right: 0px;
          background: #01a2a7;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          height: 20px;
          width: 20px;
          border-radius: 50%;
        }

        .nav-button {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;

          &.profile-btn {
            position: relative;
            top: -1px;
          }

          img.profile-logo {
            height: 30px;
            width: 30px;
            border: 3px solid var(--wecodefy-secondary-color, #9fc953);
            object-fit: cover;
            border-radius: 50%;
          }

          .empty-profile {
            height: 30px;
            width: 30px;
            border: 3px solid var(--wecodefy-secondary-color, #9fc953);
            font-size: 11px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: -5px;
            background: #000;
            color: #fff;
          }
        }

        .settings-drop-down {
          position: absolute;
          top: 28px;
          right: 8px;
          width: 200px;
          z-index: 9999;
          background: #fff;
          border-radius: 5px;
          border: 1px solid #ddd;

          .profile-widget {
            padding: 20px;
            text-align: center;
          }

          .setting-item {
            padding: 10px 13px;
            font-size: 13px;
            cursor: pointer;
            border-bottom: 1px solid #ddd;

            .icon {
              margin-right: 10px;
            }

            &:hover {
              background: #ddd;
            }
          }
        }
      }
    }
  }

  .sidebar-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 230px;
    background: var(--wecodefy-bg-color, #011616);
    z-index: 9999999;
    box-shadow: -1px 0px 26px rgba(0, 0, 0, 0.4);
    transition: 700ms ease-in-out;
    overflow-y: auto;

    .system-brand {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      padding: 10px;
      background: inherit;
      position: sticky;
      top: 0;

      .menu-btn {
        border: none;
        background: transparent;
        display: block;
        padding-left: 20px;

        @media screen and (max-width: 500px) {
          margin-left: 0px;
          padding-left: 10px;
        }

        @media screen and (max-width: 330px) {
          margin-right: 3px;
        }

        img {
          width: 26px;
        }
      }

      .brand {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;

        .logo {
          height: 100%;
          width: 100%;
          object-fit: contain;
        }
      }
    }

    .menu-list {
      ul {
        list-style: none;
        padding-left: 0px;

        li.item {
          padding: 18px 15px;
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-left: 15px;

          span {
            color: #fff;
            font-size: 15px;
            text-transform: uppercase;
            font-weight: 500;
          }

          .icon {
            font-size: 18px;
            margin-right: 20px;
            color: #fff;
            margin-top: 0px;
            width: 17px;
          }

          &.active {
            border-left: 5px solid var(--wecodefy-secondary-color, #9fc953);

            span {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            .icon {
              color: var(--wecodefy-secondary-color, #9fc953);
              margin-left: -5px;
            }
          }

          &:hover {
            transition: 100ms ease-in;

            span {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            .icon {
              color: var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }

        li.divider {
          border-bottom: 1px solid #3c3c3c;
          color: #fff;
          padding-top: 30px;
          padding-left: 25px;
          padding-bottom: 10px;
        }
      }
    }

    &.show {
      // width: 0;
      // overflow: hidden;
      left: -400px !important;
    }
  }

  .body-container {
    position: fixed;
    left: 230px;
    right: 0px;
    bottom: 0px;
    top: 60px;
    display: flex;
    flex-direction: column;
    z-index: 88;
    background: #fafafa;
    transition: 700ms ease-in-out;

    @media (max-width: 966px) {
      left: 0px !important;
    }

    &.nosidebar {
      left: 0px !important;
    }
  }


}
</style>
